<div class="container data-monitor-configure-graph">
  <b-overlay :show="modalLoading" opacity="0.8" spinner-variant="primary" rounded="lg">

    <div class="tabs-container">
      <b-tabs>
        <b-tab v-for="(tab, index) in tabKey()" :key="index"
            @click="currentTab = (tabKey()[index])"
            :active="currentTab === (tabKey()[index])"
            :title="displayPartsInfo[tabKey()[index]].tab"
          >
        </b-tab>
      </b-tabs>

      <div v-if="currentTab === tabKey()[tab().RANGE]" key="tab1" class="tab-content">
        <div class="dialog-item-label mt-2">
          {{ displayPartsInfo[currentTab].itemLabel }}
          <br>
          <b-form-select v-model = "targetItemIndex"
              class="custom-select custom-select-sm"
              :options = "getPulldownOptions()"
              :disabled="validate()"
              @change = "handleSelectionChanged" />
        </div>
        <div class="dialog-item-label mt-3">
          {{ displayPartsInfo[currentTab].rangeLabel }}
          <br>
          <b-form-radio-group size="sm" v-model="selectedRange"
            @change = "handleChangeRadioButton"
          >
            <b-form-radio class = "dialog-item-value-label"
                :value="range().DEFAULT"
                :disabled="isOnlyAutoRange(selectedConversion) || validate()"
                >
              {{ displayPartsInfo[currentTab].optionLabel.defaultRange }}
            </b-form-radio>
            <br>
            <b-form-radio class = "dialog-item-value-label"
                :value="range().AUTO"
                :disabled="isOnlyAutoRange(selectedConversion) || validate()"
                >
              {{ displayPartsInfo[currentTab].optionLabel.autoRange }}
            </b-form-radio>
            <br>
            <b-form-radio class = "dialog-item-value-label"
                :value="range().MANUAL"
                :disabled="isOnlyAutoRange(selectedConversion) || validate()"
                >
              {{ displayPartsInfo[currentTab].optionLabel.manRange }}
            </b-form-radio>
          </b-form-radio-group>
          <div v-if="selectedRange !== range().AUTO">
            <div class="ml-4 dialog-item-value-label">
              {{ displayPartsInfo[currentTab].manualMinLabel }}
              <div class="dialog-manual-range">
                <b-form-input
                    v-model="manualMinValue"
                    :disabled="(selectedRange !== range().MANUAL) || (isAlert.manualMaxValue.valid === false)"
                    :placeholder="(selectedConversion.graph_range_display.min) ? getDigitValue(selectedConversion.graph_range_display.min) : getDigitValue(0)"
                    type="number"
                    :step="getStepValue()"
                    class="dialog-manual-range-row-textfield"
                    size="sm"
                    :state="isAlert.manualMinValue.valid"
                    @input = "handleMinValueChanged()" />
                <div class="ml-2 mt-1 dialog-unit-label">
                  {{ selectedConversion.unit }}
                </div>
                <b-form-invalid-feedback>{{ $t(isAlert.manualMinValue.msg, [isAlert.manualMinValue.length]) }}</b-form-invalid-feedback>
              </div>
            </div>
            <div class="ml-4 dialog-item-value-label">
              {{ displayPartsInfo[currentTab].manualMaxLabel }}
              <div class="dialog-manual-range">
                <b-form-input
                    v-model="manualMaxValue"
                    :disabled="(selectedRange !== range().MANUAL) || (isAlert.manualMinValue.valid === false)"
                    :placeholder="(selectedConversion.graph_range_display.max) ? getDigitValue(selectedConversion.graph_range_display.max) : getDigitValue(0)"
                    type="number"
                    :step="getStepValue()"
                    class="dialog-manual-range-row-textfield"
                    size="sm"
                    :state="isAlert.manualMaxValue.valid"
                    @input = "handleMaxValueChanged()" />
                <div class = "ml-2 mt-1 dialog-unit-label">
                  {{ selectedConversion.unit }}
                </div>
                <b-form-invalid-feedback>{{ $t(isAlert.manualMaxValue.msg, [isAlert.manualMaxValue.length]) }}</b-form-invalid-feedback>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="currentTab === tabKey()[tab().TIME_GRID]" key="tab2" class="tab-content">
        <div class="dialog-item-label mt-2">
          {{ displayPartsInfo[currentTab].label }}
        </div>
        <div class="dialog-time">
          <b-form-select v-model = "xAxisGridWidth"
            class="custom-select custom-select-sm mr-1"
            :options = "displayPartsInfo[currentTab].list.map((x) => {return {'value': x, 'text': String(x, 10)}})" />
          <div class="mt-1">
            {{ displayPartsInfo[currentTab].unit }}
          </div>
        </div>
      </div>
      <div v-if="currentTab === tabKey()[tab().LINE]" key="tab3" class="tab-content">
        <div class="dialog-item-label mt-2">
          {{ displayPartsInfo[currentTab].itemLabel }}
          <br>
          <b-form-select v-model = "targetItemIndex"
              class="custom-select custom-select-sm"
              :options = "getPulldownOptions()"
              :disabled="validate()"
              @change = "handleSelectionChanged" />
        </div>
        <div class="line-config-block">
          <div class="dialog-item-label mt-3">
            {{ displayPartsInfo[currentTab].thicknessLabel }}
            <br>
            <b-dropdown class="line-config-box line-config" no-flip variant="primary">
              <template #button-content>
                <svg width="200" height="10">
                  <line x1="0%" y1="50%" x2="100%" y2="50%" stroke="black" :stroke-width="selectedThickness" />
                </svg>
              </template>
              <b-dropdown-item v-for="thickness in thicknessOptions" :key="thickness"
                @click="selectLineThickness(thickness)">
                <svg width="200" height="10">
                  <line x1="0%" y1="50%" x2="100%" y2="50%" stroke="black" :stroke-width="thickness" />
                </svg>
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <div class="dialog-item-label mt-3">
            {{ displayPartsInfo[currentTab].styleLabel }}
            <br>
            <b-dropdown class="line-config-box line-config" no-flip variant="primary">
              <template #button-content>
                <svg width="200" height="10">
                  <line x1="0%" y1="50%" x2="100%" y2="50%" stroke="black" :stroke-dasharray="selectedLineStyle" />
                </svg>
              </template>
              <b-dropdown-item v-for="lineStyle in lineStyleOptions" :key="lineStyle"
                @click="selectLineStyle(lineStyle)">
                <svg width="200" height="10">
                  <line x1="0%" y1="50%" x2="100%" y2="50%" stroke="black" :stroke-dasharray="lineStyle" />
                </svg>
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <div class="dialog-item-label mt-3">
            {{ displayPartsInfo[currentTab].colorLabel }}
            <br>
            <input class="form-control line-config-form" type="color" v-model="lineColor" @change="changeLineSetting">
          </div>
        </div>
        <div class="line-config-block">
          <div class="dialog-item-label mt-3">
            {{ displayPartsInfo[currentTab].previewLabel }}
            <br>
            <div class="form-control preview-box">
              <svg id="previewLine" class="line" width="100%" height="100%">
                <line :x1="previewLineCoordinates.x1" :y1="previewLineCoordinates.y1" :x2="previewLineCoordinates.x2"
                  :y2="previewLineCoordinates.y2" :stroke="lineColor" :stroke-width="selectedThickness"
                  :stroke-dasharray="selectedLineStyle" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-overlay>
</div>